import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const swiper = new Swiper(".hero-slider", {
    modules: [Navigation, Pagination],
    navigation: {
        nextEl: ".arrow.next",
        prevEl: ".arrow.prev",
    },
    on: {
        init: function () {
            setupCustomPagination(this);
            checkSlideCount(this);
            updateFocusableElements(this);
        },
        slideChange: function () {
            updateCustomPagination(this);
            updateFocusableElements(this);
            setTimeout(() => resetFocusToFirstElement(this), 300); // Add a delay
        },
    },
    a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
    },
});

function setupCustomPagination(swiper) {
    swiper.slides.forEach((slide, index) => {
        const pagination = slide.querySelector(".slide-pagination");
        if (!pagination) return; // Check if pagination exists
        pagination.innerHTML = "";
        swiper.slides.forEach((_, idx) => {
            const button = document.createElement("button");
            button.classList.add("dot");
            button.setAttribute("aria-label", `Go to slide ${idx + 1}`);
            button.addEventListener("click", () => {
                swiper.slideTo(idx);
            });
            pagination.appendChild(button);
        });
    });
    updateCustomPagination(swiper);
}

function updateCustomPagination(swiper) {
    swiper.slides.forEach((slide) => {
        const pagination = slide.querySelector(".slide-pagination");
        if (!pagination) return; // Check if pagination exists
        const buttons = pagination.querySelectorAll(".dot");
        buttons.forEach((button, idx) => {
            button.classList.toggle("active", idx === swiper.realIndex);
        });
    });
}

function checkSlideCount(swiper) {
    const prevArrow = document.querySelector('.arrow.prev');
    const nextArrow = document.querySelector('.arrow.next');
    const pagination = document.querySelector('.slide-pagination');
    if (swiper.slides.length <= 1) {
        if (prevArrow) prevArrow.style.display = 'none';
        if (nextArrow) nextArrow.style.display = 'none';
        if (pagination) pagination.style.display = 'none';
    }
}

function updateFocusableElements(swiper) {
    swiper.slides.forEach((slide, index) => {
        const focusableElements = slide.querySelectorAll('a, button, input, textarea, select, details, [tabindex]');
        focusableElements.forEach(el => {
            el.tabIndex = (index === swiper.activeIndex) ? 0 : -1;
        });
    });
}

function resetFocusToFirstElement(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const focusableElements = activeSlide.querySelectorAll('a, button, input, textarea, select, details, [tabindex]');
    if (focusableElements.length > 0) {
        focusableElements[0].focus();
    }
}
